import { Search, X } from "lucide-react"

export default function CommunityFeedFilters({
  tagFilter,
  onTagChange,
  className,
}) {
  return (
    <div className={className}>
      <div className="relative flex-1 min-w-[140px] max-w-[260px]">
        <Search className="absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
        <input
          placeholder="Filter by tag (#)"
          value={tagFilter ?? ""}
          onChange={(e) => {
            const raw = e.target.value.trim()
            const normalized = raw ? raw.replace(/^#/, "").toLowerCase() : null
            onTagChange(normalized)
          }}
          className="w-full pl-8 bg-gray-800/30 h-8 text-sm rounded-md border border-gray-800/60 focus:outline-none focus:ring-1 focus:ring-emerald-500/40"
        />
        {tagFilter ? (
          <button
            type="button"
            className="absolute right-1 top-1/2 -translate-y-1/2 h-6 w-6 rounded-md hover:bg-gray-800/60 transition-colors flex items-center justify-center"
            onClick={() => onTagChange(null)}
            aria-label="Clear tag filter"
          >
            <X className="h-3.5 w-3.5 text-gray-300" />
          </button>
        ) : null}
      </div>
    </div>
  )
}

